'use strict';

import Reflux from 'reflux';

export default class AbstractStore
{
    constructor(actions) {
        this.store = Reflux.createStore({});
        this.actions = Reflux.createActions(actions);

        this.listenToMany(this.actions);
    }

    listenTo(action, handler) {
        this.store.listenTo(action, handler);
    }

    listenToMany(actions) {
        for (var action in actions) {
            if (actions.hasOwnProperty(action)) {
                let actionName = `${action}`;
                let handlerName = `on${actionName.substring(0,1).toUpperCase()}${actionName.substring(1)}`;
                this.store.listenTo(actions[action], (...args) => {
                    let handler = this[handlerName].bind(this);
                    if (handler) {
                        handler(...args);
                    }
                })

            }
        }
    }

    listen(handler) {
        return this.store.listen(handler);
    }

    trigger(...args) {
        this.store.trigger(...args);
    }
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Common/Stores/AbstractStore.jsx